import gql from 'graphql-tag';
import {TIPO_ESTADO_ENVIOS} from '@/resources/constants';

export const QUERY_DETALLE_RECLAMACION = gql(`
   query BusquedaReclamacion($token: String, $idioma: String){
      reclamacion(token:$token){
         token
         tramitadorUuid
         notarioUuid
         estado                      
         divisa
         viaJudicial
         viaJudicialFavorable
         fechaPublicacion
         fechaSuspension
         motivoSuspension
         motivoCancelacion
         iban
         notas
         fechaAlta
         totalPendiente
         avisos
         noNotificar
         uuid
         contactoEmail{
            id
            tipo
            valor{
               email
            }
            activo
         }
         contactoTelefono{
            id
            tipo
            valor{
               telefono
            }
            activo
         }
         contactoDireccion{
            activo
            valor {
               direccion
               localidad
               provincia
               codigoPostal
               pais
            }
            literalTipoVia(idioma: $idioma){
               clave
               valor
            }
            literalPais(idioma: $idioma){
               clave
               valor
            }
            literalProvincia(idioma: $idioma){
               clave
               valor
            }
         }
         listadoTransiciones {
            estadoPrevio
            estadoPosterior
         }
         operacion {
            origenDeuda
            literalOrigenDeudaDetalle(idioma: $idioma) {
               clave
               valor
            }
         }   
         producto {
            codigoProducto
            literalProducto(idioma: $idioma) {
               valor
            }
            contrato {
               tipo
               cliente {
                  id
                  nombre
                  apellidos
                  iban
                  fechaAlta
                  idLegal
               }
            }
         } 
         grafoRutaEstados(idioma: $idioma) {
            clave
            valor 
         } 
         impagos {
            uuid
            token
            importe
            importePendiente
            fechaVencimiento
            fechaOrigen
            recuperado
            notas
            fechaAlta
            pagos {
               importe
               importeRecuperado
               divisa
               fechaPago
               fechaAlta
            }
         }
         literalEstado(idioma: $idioma){
            valor
         }              
         literalMotivoCancelacion(idioma: $idioma) {
            valor
         } 
         literalMotivoSuspension(idioma: $idioma) {
            valor
         }
         envioRequerimientoBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_NOTIFICACION + `"){
            estado
            envioEncontradoBBDD
            literalCodigoEnvio(idioma: $idioma){
               valor
            }
            literalEstadoEnvio(idioma: $idioma){
               valor
            }
            literalTipoEnvio(idioma: $idioma){
               valor
            }
            fechaEnvio
            localizadorProveedor
            numeroSeguimiento
            token
            uuidPeticionEnvio
            tipoEnvio
            servicioProveedor
            certPdf
            postalNote
            postalCert
            stampedContent
            documentosReqInc {
               tipo
               clave
               filename
             }
         }
         envioInclusionBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_PUBLICACION + `"){
            estado
            envioEncontradoBBDD
            literalCodigoEnvio(idioma: $idioma){
               valor
            }
            literalEstadoEnvio(idioma: $idioma){
               valor
            }
            literalTipoEnvio(idioma: $idioma){
               valor
            }
            fechaEnvio
            localizadorProveedor
            numeroSeguimiento
            token
            uuidPeticionEnvio
            tipoEnvio
            servicioProveedor
            certPdf
            postalNote
            postalCert
            stampedContent
            documentosReqInc {
               tipo
               clave
               filename
             }
         }
         acreedor {
            id
            apellidos 
            cnae                           
            fechaAlta
            idLegal
            nombre
            razonSocial
            tipo
            iban
            contactosActivos {
               direccion {
                  activo
                  valor {
                     direccion
                     localidad
                     provincia
                     codigoPostal
                     pais
                  }
                  literalTipoVia(idioma: $idioma){
                     clave
                     valor
                  }
                  literalPais(idioma: $idioma){
                     clave
                     valor
                  }
                  literalProvincia(idioma: $idioma){
                     clave
                     valor
                  }
               }
               email {
                  activo
                  valor {
                     email
                  }
               }
               telefono {
                  activo
                  valor {
                     telefono
                  }
               }
            }
            literalTipoUsuarioDetalle(idioma: $idioma) {
               valor
            } 
            literalTipoSociedadDetalle(idioma: $idioma) {
               valor
            }                    
         }
         deudor {
            id
            apellidos 
            cnae                           
            fechaAlta
            idLegal
            nombre
            razonSocial
            tipo
            contactosActivos {
               direccion {
                  activo
                  valor {
                     direccion
                     localidad
                     provincia
                     codigoPostal
                     pais
                  }
                  literalTipoVia(idioma: $idioma){
                     clave
                     valor
                  }
                  literalPais(idioma: $idioma){
                     clave
                     valor
                  }
                  literalProvincia(idioma: $idioma){
                     clave
                     valor
                  }
               }
               email {
                  activo
                  valor {
                     email
                  }
               }
               telefono {
                  activo
                  valor {
                     telefono
                  }
               }
            }
            literalTipoUsuarioDetalle(idioma: $idioma) {
               valor
            } 
            literalTipoSociedadDetalle(idioma: $idioma) {
               valor
            }                    
         }
         traza {
            id
            estadoPrevio
            estado
            fecha
            comentario
            literalEstado(idioma: $idioma) {
               valor
            } 
         }   
         actaProvisionalDoc {
            filename
            tipo
            clave
         }
         actaProvisionalBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_ACTA_PROVISIONAL + `"){
            envioEncontradoBBDD
            estado
            localizadorProveedor
            servicioProveedor
         } 
         actaDefinitivaDoc {
            filename
            tipo
            clave
         }
         actaDefinitivaBBDD:estadoEnvio(tipoEnvio: "` + TIPO_ESTADO_ENVIOS.TIPO_ENVIO_ACTA_DEFINITIVA + `"){
            envioEncontradoBBDD
            estado
            localizadorProveedor
            servicioProveedor
         }      
      }
      listadoOrigenesDeuda(idioma: $idioma) {
         clave
         valor
      }
      
   }
`);

export const QUERY_LISTADO_RECLAMACION = gql(`
query BusquedaReclamaciones($filter: [String], $sort: [String], $page: Int!, $size: Int!, $idioma: String!){
   listaReclamaciones ( criteria: { filter: $filter, sort: $sort, page: $page, size: $size } ) {
      totalElements
      firstElement
      results {
           acreedorApellidos	
           acreedorIdLegal	
           acreedorNombre
           acreedorRazonSocial
           acreedorTipoSociedad
           acreedorUuid
           clienteApellidos
           clienteId
           clienteIdLegal
           clienteNombre
           deudorApellidos
           deudorIdLegal
           deudorNombre
           deudorRazonSocial
           deudorTipoSociedad
           deudorUuid
           divisa
           estado
           fechaAlta
           productoCodigo
           productoId
           token
           totalImpagos
           totalPendiente
           tramitadorApellidos
           tramitadorEmail
           tramitadorNombre
           tramitadorUuid
           literalEstado(idioma: $idioma) {
               valor
           }
           literalProducto(idioma: $idioma) {
               valor
           }
      }
   }
}`)

export const MODIFICAR_AVISOS_FLAG = gql(`
   mutation configurarReclamacion($token:String, $avisos:Boolean){
      configurarReclamacion(tokenReclamacion:$token, request: { avisos:$avisos}){
         token
         avisos
      }
   }`);

export const MODIFICAR_NOTIFICACIONES_FLAG = gql(`
   mutation configurarReclamacion($token:String, $notificaciones:Boolean){
      configurarReclamacion(tokenReclamacion:$token, request: { notificaciones:$notificaciones}){
         token
         notificaciones
      }
   }`);

export const MODIFICAR_ORIGEN_DEUDA = gql(`
   mutation configurarReclamacion($token:String, $origen:String, $viaJudicial:Boolean, $viaJudicialFavorable:Boolean, $iban:String, $camposABorrar:[String]){
      configurarReclamacion(tokenReclamacion:$token, request: { origen:$origen, viaJudicial:$viaJudicial, viaJudicialFavorable:$viaJudicialFavorable, iban:$iban, camposABorrar:$camposABorrar}){
         token
         origen
         viaJudicial
         viaJudicialFavorable
         iban
      }
   }`); 

export const MODIFICAR_NOTAS = gql(`
   mutation configurarReclamacion($token:String, $notas:String){
      configurarReclamacion(tokenReclamacion:$token, request: { notas:$notas}){
         token
         notas
      }
   }`);   

export const ADD_AGENTE_RECLAMACION = gql(`
   mutation asignarAgente($agente: String!, $token:String){
      asignarAgenteReclamacion(agenteUuid:$agente, tokenReclamacion:$token){
         statusCode
         message
         errorMessage
      }
   }`);

export const EN_NOTARIA_RECLAMACION = gql(`
    mutation asignarNotarioReclamacion($token:String, $notarioUuid:String){
        asignarNotarioReclamacion(tokenReclamacion:$token, notarioUuid:$notarioUuid){
            statusCode
            message
            errorMessage
        }
    }`);
    
export const QUERY_AGRUPACION_CONTEO_RECLAMACIONES = gql(`
    query agrupacionConteoPorReclamacion($filter: [String], $page: Int!, $size: Int!, $groupField1: String!, $groupField2: String!, $groupField3: String!){
        statuses:agrupacionReclamaciones(criteria: { filter: $filter, page: $page, size: $size}, groupField: $groupField1) {
            groupCount
            totalCount
            groupList {
                group 
                count         
            }
        }
        products:agrupacionReclamaciones(criteria: { filter: $filter, page: $page, size: $size}, groupField: $groupField2) {
            groupCount
            totalCount
            groupList {
                group 
                count         
            }
        }
        agents:agrupacionReclamaciones(criteria: { filter: $filter, page: $page, size: $size}, groupField: $groupField3) {
            groupCount
            totalCount
            groupList {
                group 
                count         
            }
        }
    }`)



export const QUERY_LISTADOS_LITERALES_ESTADOS =  gql(`
    query listadoLiterales($idioma: String!){
        statuses:listadoEstados(idioma: $idioma) {
            clave
            valor
        }
    }`) 


export const QUERY_CONTEO_RECLAMACIONES = gql(`
   query conteos($filter: [String], $page: Int!, $size: Int!){
      conteoReclamaciones(criteria: { filter: $filter, page: $page, size: $size})
   }`)


export const LISTADO_MOTIVOS_CANCELACION = `listadoMotivosCancelacionReclamacion(idioma: $idioma) {
   codigo
   clave
   valor 
   idioma
}`
export const LISTADO_MOTIVOS_SUSPENSION = `listadoMotivosSuspension(idioma: $idioma) {
   codigo
   clave
   valor 
   idioma
}`

export const QUERY_LISTADO_MOTIVOS_CANCELACION =  gql(`
    query listadoMotivosCancelacion($idioma: String!) {
        ` + LISTADO_MOTIVOS_CANCELACION + `
    }`
);  

export const QUERY_LISTADO_MOTIVOS_SUSPENSION =  gql(`
    query listadoMotivosSuspension($idioma: String!) {
        ` + LISTADO_MOTIVOS_SUSPENSION + `
    }`
);

export const MUTATION_ALTA_RECLAMACION = gql(`
   mutation altaReclamacion($input: AltaReclamacionRequestInput){
      altaReclamacion(altaReclamacion:$input){
         uuid
         token
      }
   }
`);

export const MUTATION_ALTA_RECLAMACION_MENSAJE = gql(`
   mutation altaMensajeReclamacion($input: AltaMensajeReclamacionRequestInput){
      altaMensajeReclamacion(altaMensajeReclamacionRequest:$input){
         archivos {
            filename
            tipo
            id
         }
         fecha
         mensaje
         usuario {
            nombre
            apellidos
            genero
         }
      }
   }
`);

export const QUERY_LISTADO_MENSAJES_RECLAMACION = gql(`
   query listaMensajeReclamacion($criteria: ItemCriteriaInput) {
      listaMensajeReclamacion(criteria: $criteria){
         firstElement
         totalElements
         results {
            id
            archivos {
               filename
               tipo
               id
            }
            fecha
            mensaje
            usuario {
               nombre
               apellidos
               genero
               tipo
            }
         }
      }
   }
`);

export const QUERY_CHECK_RECLAMACION_ANEXABLE = gql(`
   query checkReclamacionAnexable($idLegalCliente: String, $origen: String, $producto: String, $uuidDeudor: UUID, $uuidAcreedor: UUID, $uuidUsuario: UUID, $idLegalAcreedor: String, $idLegalDeudor: String, $tipoAcreedor: String, $tipoDeudor: String) {
      checkReclamacionAnexable(idLegalCliente: $idLegalCliente, origen: $origen, producto: $producto, uuidDeudor: $uuidDeudor, uuidAcreedor: $uuidAcreedor, uuidUsuario: $uuidUsuario, idLegalAcreedor: $idLegalAcreedor, idLegalDeudor: $idLegalDeudor, tipoAcreedor: $tipoAcreedor, tipoDeudor: $tipoDeudor){
         anexable
         tokenOperacion
      }
   }
`);  



export const BOTONERA_ESTADOS_POSIBLES_PARA_EJECUTAR_ACCION = gql(`
   query estadosPredecesoresPorAccion($nombre: String){
      listadoEstadosPredecesores(nombre: $nombre){
         nombre
         estadosPredecesores 
      }
   }
`);

export const MUTATION_CANCEL_CLAIM = gql(`
   mutation cancelarReclamacion($usuarioUuid: String, $tokenReclamacion: String, $motivoCancelacion: String){
      cancelarReclamacion(usuarioUuid: $usuarioUuid, tokenReclamacion: $tokenReclamacion, motivoCancelacion: $motivoCancelacion){
         request {
            motivoCancelacion
         }
      }
   }
`);


export const MUTATION_SUSPEND_CLAIM = gql(`
   mutation suspenderReclamacion($usuarioUuid: String, $tokenReclamacion: String, $motivoSuspension: String, $fechaLimite: Long){
      suspenderReclamacion(usuarioUuid: $usuarioUuid, tokenReclamacion: $tokenReclamacion, motivoSuspension: $motivoSuspension, fechaLimite: $fechaLimite){
         request {
            tokenReclamacion
         }
      }
   }
`);

export const MUTATION_RECOVER_CLAIM = gql(`
   mutation recuperarReclamacion($recuperadoAutomatico: Boolean, $tokenReclamacion: String, $usuarioUuid:String){
      recuperarReclamacion(recuperadoAutomatico: $recuperadoAutomatico, tokenReclamacion: $tokenReclamacion, usuarioUuid: $usuarioUuid){
         pago {
            divisa
            fechaPago
            importe
         }
      }
   }
`);


export const BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO = gql(`
   mutation ordenPagoImpago($ordenPagoImpagoRequest: OrdenPagoImpagoRequestInput){
      ordenPagoImpago(ordenPagoImpagoRequest: $ordenPagoImpagoRequest){
         pago {
            divisa
            fechaPago
            importe
         }
      }
}`);

export const BOTONERA_ESTADOS_PREDECESORES_ACCION = gql(`
   query listadoEstadosPredecesoresPorAccion($accion: String){
      listadoEstadosPredecesores(nombre: $accion) {
         nombre
         estadosPredecesores 
      }
}`);